import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { maskPhone } from "@/lib/format";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name:"", email:"", password:"", phone:"" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Cadastro realizado! Bem-vinda à Lara B. 💗");
      nav("/minha-conta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao cadastrar");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#F9E1E8] p-8 shadow-sm">
        <div className="text-center mb-6"><Logo /></div>
        <h1 className="font-serif text-2xl text-[#4A3B40] text-center mb-6">Criar conta</h1>
        <form onSubmit={submit} className="space-y-3">
          <input required placeholder="Nome completo" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} className="input-l" data-testid="register-name" />
          <input required type="email" placeholder="E-mail" value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})} className="input-l" data-testid="register-email" />
          <input placeholder="Celular/WhatsApp" value={form.phone} onChange={(e)=>setForm({...form, phone:maskPhone(e.target.value)})} className="input-l" data-testid="register-phone" />
          <input required type="password" placeholder="Senha" value={form.password} onChange={(e)=>setForm({...form, password:e.target.value})} className="input-l" data-testid="register-password" />
          <button disabled={loading} className="w-full btn-lara" data-testid="register-submit">{loading?"Criando...":"Criar conta"}</button>
        </form>
        <p className="text-sm text-center text-[#8C7A80] mt-4">
          Já tem conta? <Link to="/login" className="text-[#C9708B] font-semibold hover:underline">Entrar</Link>
        </p>
        <style>{`.input-l{width:100%;border:1px solid #F9E1E8;background:#FFF9FA;border-radius:12px;padding:12px 16px;outline:none;color:#4A3B40}.input-l:focus{border-color:#C9708B}`}</style>
      </div>
    </div>
  );
}
